<div
  [class.no-shadow]="megaMenuDesktopOpen()"
  [ngClass]="widgetCssClassName()"
  [ngStyle]="{ 'position': fixedWidget() === true ? 'fixed' : 'relative' }"
  class="search-widget-v2-desktop-container"
>
  @if (isStateLoaded()) {
    <div class="search-widget-v2-desktop">
      <div class="search-widget-v2-desktop__mega-menu-button">
        <app-ui-button
          (onClick)="megamenu.toggle()"
          [color]="'outline-green'"
          [disabled]="false"
          [expanded]="'inline'"
          [size]="'lg'"
          class="test-mega-menu-button"
        >
          @if (!megaMenuDesktopOpen()) {
            <app-ui-icon name="list"></app-ui-icon>
          }

          Alla kategorier

          @if (megaMenuDesktopOpen()) {
            <app-ui-icon name="close"></app-ui-icon>
          }
        </app-ui-button>
      </div>


      <div class="search-widget-v2-desktop__free-search">
        <app-free-search
          (freeSearchClear)="onFreeSearchClear()"
          (freeSearchClicked)="onFreeSearchClick()"
          (freeSearchEnterHit)="onFreeSearchEnterHit($event)"
          (freeSearchOptionSelected)="onFreeSearchOptionSelected($event)"
          [theme]="theme()"
        ></app-free-search>
      </div>
      <div class="search-widget-v2-desktop__places">
        <app-places-fake-dropdown-v2
          (changePlaceDropdownState)="onChangePlaceDropdownState($event)"
          (freeSearchClear)="onPlacesFreeSearchClear()"
          (freeSearchEnterHit)="onPlacesFreeSearchEnterHit($event)"
          (freeSearchOptionSelected)="onPlacesSearchOptionSelected($event)"
          [pageType]="pageType()"
          [theme]="theme()"
        ></app-places-fake-dropdown-v2>
      </div>
      <div class="search-widget-v2-desktop__buttons">
        <app-ui-button
          (onClick)="onSubmitClick($event)"
          [color]="'green'"
          [compressed]="isTablet()"
          [disabled]="!isSubmitButtonActive()"
          [expanded]="'block'"
          [size]="'lg'"
          class="test-search-btn"
        >
          Sök
        </app-ui-button>
      </div>
    </div>
  }

  <app-places-dropdown-panel-v2
    (placesOptionSelected)="onPlacesSearchOptionSelected($event)"
    [cols]="3"
    [includeFollowLinks]="true"
    [topSearchSpacerHeight]="panelHeight"
  ></app-places-dropdown-panel-v2>
  <div class="search-widget-v2-desktop__mega-menu">
    <app-mega-menu-desktop
      #megamenu
      (onMegaMenuClick)="onMegaMenuClick()"
      [theme]="theme()"
    ></app-mega-menu-desktop>
  </div>
</div>
